module.exports = __webpack_public_path__ + "img/img01.2ce2cf0f.jpg";